module.exports = __webpack_public_path__ + "img/logo-forum-risk-management-2021.1d71254e.svg";